import * as storeHelpers from '../stores/helpers';
/**
 * optimistically update the item in the FE.
    - item in feedStore.itemsDict
    - item + group relations
    if the BE update fails, rollback FE operation.
    - rollback item in current view
    - rollback item in feedStore.itemsDict
 */
export async function saveItems(payload) {
    // optimistically make local frontend changes.
    storeHelpers.updateItems({
        itemIDs: Object.values(payload.currentItemGroups),
        tagsToAdd: payload.tagsToAdd,
        tagsToRemove: payload.tagsToRemove,
        // groupsToAdd: payload.groupsToAdd,
        // groupsToRemove: payload.groupsToRemove
    });
    const response = await fetch('/api/v1/add-items', {
        body: JSON.stringify(payload),
        method: 'POST',
    });
    const responseJson = await response.json();
    const { newItems } = responseJson;
    if (newItems === null || newItems === void 0 ? void 0 : newItems.length) {
        storeHelpers.addItems({
            items: newItems,
            tagsToAdd: payload.tagsToAdd
        });
    }
    // if server request was unsuccessful, rollback local changes
    return responseJson;
}
